<template>
  <v-navigation-drawer
    class="shadow-small"
    v-model="Drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    absolute
    temporary
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">FlexTD</v-list-item-title>
        <!-- <v-list-item-subtitle>
          subtext
        </v-list-item-subtitle>-->
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list dense v-for="item in userPermission" :key="item.text">
      <v-list-group
        v-if="item.children"
        :key="item.text"
        v-model="item.model"
        :prepend-icon="item.icon"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          v-for="(child, i) in item.children"
          :key="i"
          link
          @click="router(child.href)"
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ child.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item :key="item.text" v-else link @click="router(item.href)">
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        icon: "mdi-view-module",
        text: "Catálogo de productos",
        href: "product_catalog",
        permission: "8",
      },
      {
        icon: "mdi-cart",
        text: "Orden de compras",
        href: "purchase_order",
        permission: "9",
      },
      {
        icon: "mdi-receipt",
        text: "Seguimiento de pedidos",
        href: "order_tracking",
        permission: "10",
      },
      // {
      //   icon: "mdi-format-list-bulleted-type",
      //   text: "Publicar Producto",
      //   href: "categories",
      //   permission: "7"
      // },
      // {
      //   icon: "mdi-format-list-bulleted-type",
      //   text: "Productos Publicados",
      //   href: "published_products",
      //   permission: "7"
      // }
    ],
  }),
  computed: {
    Drawer: {
      get() {
        let d = this.$store.getters["layout/DRAWER_STATE"];
        return d === null ? true : d;
      },
      set(val) {
        this.$store.commit("layout/SET_DRAWER", val);
      },
    },
    userPermission() {
      let userPermission =
        this.$store.getters["auth/GET_PERMISSION_USER"] || [];
      userPermission.push(8, 9, 10);
      let arrayList = this.items;
      let listPermission = arrayList.filter((val) => {
        if (userPermission.includes(parseInt(val.permission))) {
          return val;
        }
      });
      return listPermission;
    },
  },
  methods: {
    router(route) {
      this.$router.push({ name: route }).catch((err) => {
        return err;
      });
    },
  },
};
</script>

<style>
.shadow-small {
  box-shadow: 0 2px 4px rgba(27, 31, 35, 0.15) !important;
}
</style>
